import "core-js/modules/es6.string.small.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "global-footer layout-without-background",
    class: _vm.isLastElement
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row align-items-stretch justify-content-md-center",
    class: [_vm.theParagraph ? ' pb-md-3' : 'pb-2 pb-md-4']
  }, [_c('div', {
    staticClass: "col-12 col-sm-10 col-lg-8 gutter-only-mobile text-left text-sm-center",
    style: {
      color: _vm.currentPayload.textColor
    }
  }, [_c('GlobalRichText', {
    attrs: {
      "payload": _vm.currentPayload.title
    }
  }), _vm._v(" "), _c('GlobalRichText', {
    attrs: {
      "payload": _vm.currentPayload.subtitle,
      "cls": 'subtitle valentine'
    }
  }), _vm._v(" "), _c('SimpleParagraph', {
    attrs: {
      "paragraph": _vm.currentPayload.paragraph
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row bg-gb-footer py-4 py-md-0",
    style: {
      background: _vm.bgColor
    }
  }, [_c('div', {
    staticClass: "global-selection-wrapper gutter-only-mobile col-12 d-sm-flex justify-content-md-center flex-wrap pb-0 pb-sm-4"
  }, _vm._l(_vm.currentPayload.selections, function (selection, key) {
    return _c('GlobalSelection', {
      key: key,
      staticClass: "col-12 pb-3 px-0 px-md-2 px-lg-3",
      class: _vm.dynamicColumns,
      attrs: {
        "url": selection.url,
        "src": "".concat(selection.image.small, " 320w, ").concat(selection.image.large, " 380w"),
        "text-color": selection.textColor,
        "title": selection.title,
        "description": selection.description,
        "cta": selection.cta
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.$root.$emit('generic-tracking', $event, selection.tracking);
        }
      }
    });
  }), 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };